import React, { Fragment } from "react";
import { Dialog } from "@headlessui/react";
import { useModal } from "hooks/Modal";

export default function ModalTitle() {
    const { state } = useModal();

    return (
        <Fragment>
            {state.title && (
                <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                >
                    {state.title}
                </Dialog.Title>
            )}
        </Fragment>
    );
}
